import { registerIcon } from "@ui5/webcomponents-base/dist/asset-registries/Icons.js";
import { ICON_SEARCH } from "../generated/i18n/i18n-defaults.js";

const name = "search";
const pathData = "M489 436q7 7 7 18t-7.5 18.5T470 480t-18-7L352 373q-26 20-58.5 31.5T224 416q-44 0-82-16t-66-44-44-66-16-82 16-82 44-66 66-44 82-16 82 16 66 44 44 66 16 82q0 37-11.5 69.5T389 336zm-265-71q33 0 61.5-12t50-33.5 33.5-50 12-61.5-12-61.5-33.5-50-50-33.5T224 51t-61.5 12-50 33.5-33.5 50T67 208t12 61.5 33.5 50 50 33.5 61.5 12z";
const ltr = true;
const accData = ICON_SEARCH;
const collection = "SAP-icons-v5";
const packageName = "@ui5/webcomponents-icons";

registerIcon(name, { pathData, ltr, accData, collection, packageName });

export default "SAP-icons-v5/search";
export { pathData, ltr, accData };